"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyManagerContract = void 0;
const multi_transaction_1 = require("multi-transaction");
const utils_1 = require("../../utils");
class StrategyManagerContract {
    contractId;
    adapter;
    constructor(contractId, adapter) {
        this.contractId = contractId;
        this.adapter = adapter;
    }
    // ------------------------------ View ---------------------------------
    async getMinimumWithdrawalDelay({ blockQuery, }) {
        return this.adapter.view({
            contractId: this.contractId,
            methodName: 'get_minimum_withdrawal_delay',
            blockQuery,
        });
    }
    async getStrategiesWithdrawalDelay({ strategies, blockQuery, }) {
        return this.adapter.view({
            contractId: this.contractId,
            methodName: 'get_strategies_withdrawal_delay',
            args: {
                strategies,
            },
            blockQuery,
        });
    }
    async getStrategyNum({ blockQuery }) {
        return this.adapter.view({
            contractId: this.contractId,
            methodName: 'get_strategy_num',
            blockQuery,
        });
    }
    async getStrategy({ strategyId, blockQuery, }) {
        return this.adapter.view({
            contractId: this.contractId,
            methodName: 'get_strategy',
            args: {
                id: strategyId,
            },
            blockQuery,
        });
    }
    async getStrategies({ fromIndex, limit, blockQuery, }) {
        return this.adapter.view({
            contractId: this.contractId,
            methodName: 'get_strategies',
            args: {
                from_index: fromIndex,
                limit,
            },
            blockQuery,
        });
    }
    async getDeposits({ staker, fromIndex, limit, blockQuery, }) {
        return this.adapter.view({
            contractId: this.contractId,
            methodName: 'get_deposits',
            args: {
                staker,
                from_index: fromIndex,
                limit,
            },
            blockQuery,
        });
    }
    async getQueuedWithdrawals({ staker, fromIndex, limit, blockQuery, }) {
        return this.adapter.view({
            contractId: this.contractId,
            methodName: 'get_queued_withdrawals',
            args: {
                staker,
                from_index: fromIndex,
                limit,
            },
            blockQuery,
        });
    }
    // ------------------------------ Change -------------------------------
    async depositIntoStrategy({ strategyId, tokenId, amount, gas, callbackUrl, }) {
        const storageBalance = await this.adapter.view({
            contractId: this.contractId,
            methodName: 'storage_balance_of',
            args: {
                account_id: this.adapter.accountId,
            },
        });
        const mtx = multi_transaction_1.MultiTransaction.new();
        if (!storageBalance) {
            mtx.batch(this.contractId).functionCall({
                methodName: 'storage_deposit',
                args: {
                    account_id: this.adapter.accountId,
                },
                attachedDeposit: multi_transaction_1.Amount.parse(0.1, 'NEAR'),
                stringifier: (0, utils_1.stringifierWithJsonOnlyArgs)(),
            });
        }
        mtx.batch(tokenId).functionCall({
            methodName: 'ft_transfer_call',
            args: {
                receiver_id: this.contractId,
                amount,
                msg: (0, utils_1.jsonSerialize)({
                    DepositIntoStrategy: {
                        strategy_id: strategyId,
                    },
                }),
            },
            attachedDeposit: multi_transaction_1.Amount.ONE_YOCTO,
            gas: gas ?? multi_transaction_1.Gas.parse(100, 'T'),
            stringifier: (0, utils_1.stringifierWithJsonOnlyArgs)(),
        });
        await this.adapter.send(mtx, { callbackUrl, throwReceiptErrors: true });
    }
    async queueWithdrawals({ queuedWithdrawalParams, gas, callbackUrl, }) {
        const numWithdraws = queuedWithdrawalParams.length;
        const mtx = multi_transaction_1.MultiTransaction.batch(this.contractId)
            .functionCall({
            methodName: 'storage_deposit',
            args: {
                account_id: this.adapter.accountId,
            },
            attachedDeposit: multi_transaction_1.Amount.parse(0.005 * numWithdraws, 'NEAR'),
            stringifier: (0, utils_1.stringifierWithJsonOnlyArgs)(),
        })
            .functionCall({
            methodName: 'queue_withdrawals',
            args: {
                queued_withdrawal_params: queuedWithdrawalParams,
            },
            attachedDeposit: multi_transaction_1.Amount.ONE_YOCTO,
            gas: gas ?? multi_transaction_1.Gas.parse(50 + 10 * numWithdraws, 'T'),
            stringifier: (0, utils_1.stringifierWithJsonOnlyArgs)(),
        });
        await this.adapter.send(mtx, { callbackUrl });
    }
    async completeQueuedWithdrawals({ withdrawals, batchSize = 5, gas, callbackUrl, }) {
        if (batchSize > 10) {
            throw Error('Batch size should be no more than 10');
        }
        const mtx = multi_transaction_1.MultiTransaction.new();
        withdrawals = Array.from(withdrawals);
        while (withdrawals.length > 0) {
            const _withdraws = withdrawals.splice(0, batchSize);
            mtx.batch(this.contractId).functionCall({
                methodName: 'complete_queued_withdrawals',
                args: {
                    withdrawals: _withdraws,
                },
                attachedDeposit: multi_transaction_1.Amount.ONE_YOCTO,
                gas: gas ?? multi_transaction_1.Gas.parse(50 + 25 * _withdraws.length, 'T'),
                stringifier: (0, utils_1.stringifierWithJsonOnlyArgs)(),
            });
        }
        await this.adapter.send(mtx, { callbackUrl, throwReceiptErrors: true });
    }
}
exports.StrategyManagerContract = StrategyManagerContract;
//# sourceMappingURL=StrategyManagerContract.js.map